require(['Carousel', 'imageLazyLoad', 'htmlSectionLazyLoad', 'locationCountsGetter', 'initialLoadModalHandler', 'popularMarketsPills'],
  function (Carousel) {
    var testimonialCarousel = new Carousel(document.getElementById("testimonialContainer"), {
      stepSize: 1,
      controls: true,
      visibleItems: 1,
      rightArrow: document.querySelector('[data-rigth]'),
      leftArrow: document.querySelector('[data-left]')
    });

    if (window.NewHomeSource.InitialLoadModalHandler) {
      window.NewHomeSource.InitialLoadModalHandler.DisplayModal();
    }
  });
define("nhs/views/home/Show", function(){});

